import CargoCompanyAddressFetchInitDataResponse, {
  CargoCompanyAddressFetchInitDataResponseType,
} from "../../../../api/raily/cargo-company/address/fetch-init-data/cargo-company-address-fetch-init-data.response";
import CargoAddressType from "../../../../types/cargo-address-type";
import CargoCompanyAddressFetchInitData from "./cargo-company-address-fetch-init-data";

const createType = (
  type: CargoCompanyAddressFetchInitDataResponseType,
): CargoAddressType => {
  switch (type) {
    case CargoCompanyAddressFetchInitDataResponseType.HOTEL:
      return CargoAddressType.HOTEL;
    case CargoCompanyAddressFetchInitDataResponseType.MEETING_POINT:
      return CargoAddressType.MEETING_POINT;
    case CargoCompanyAddressFetchInitDataResponseType.STATION:
      return CargoAddressType.STATION;
  }
};

const create = (
  response: CargoCompanyAddressFetchInitDataResponse,
): CargoCompanyAddressFetchInitData => {
  const data = response.data;

  return {
    apartment: data.apartment,
    country: data.country,
    description: data.description,
    houseNo: data.houseNo,
    lat: data.lat,
    lon: data.lon,
    street: data.street,
    town: data.town,
    type: createType(data.type),
    zipCode: data.zipCode,
  };
};

const cargoCompanyAddressFetchInitDataFactory = {
  create,
};

export default cargoCompanyAddressFetchInitDataFactory;
